// src/components/common/Tabs.jsx
import React, { useState } from "react";

export default function Tabs({ tabs }) {
  const [active, setActive] = useState(0);
  return (
    <>
      {/* Tab headers */}
      <nav className="flex border-b">
        {tabs.map((t, i) => (
          <button
            key={t.label}
            type="button"
            onClick={() => setActive(i)}
            className={`px-4 py-2 text-sm font-medium -mb-px border-b-2
              ${i === active
                ? "border-indigo-600 text-indigo-600"
                : "border-transparent text-gray-600 hover:text-gray-800"}`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {/* Tab body */}
      <div className="pt-6">{tabs[active].component}</div>
    </>
  );
}
